import { NodeType } from "@features/builder/graph/types"
import { linkParse } from "@components/NodeLink/linkHelpers"
import { NavigateNext } from "@mui/icons-material"
import { Breadcrumbs, Chip, SxProps, Tooltip } from "@mui/material"
import { getNodeTypeColor } from "@utils/node"

interface NodeLinkChipTooltipFormatterProps extends React.PropsWithChildren {
  limitChipWidth?: boolean
  title: string
  chipLabel: string
}

const NodeLinkChipTooltipFormatter = (props: NodeLinkChipTooltipFormatterProps) => {
  if (props.limitChipWidth) {
    return (
      <>
        {props.title}
        <br />
        {props.chipLabel}
      </>
    )
  }

  return props.title
}

type NodeLinkChipsProps = {
  link: string
  type: NodeType | undefined
  limitChipWidth?: boolean
}

const NodeLinkChips = (props: NodeLinkChipsProps) => {
  const link = linkParse(props.link)
  if (!link) return

  const sx: SxProps = {
    ".MuiBreadcrumbs-separator": { m: 0 },
  }
  if (props.limitChipWidth) {
    sx[".MuiBreadcrumbs-li"] = { "max-width": 225 }
  }

  return (
    <Breadcrumbs separator={<NavigateNext fontSize="small" />} sx={sx}>
      <Tooltip
        title={
          <NodeLinkChipTooltipFormatter
            limitChipWidth={props.limitChipWidth}
            title="Organisation"
            chipLabel={link.org}
          />
        }
      >
        <Chip color="primary" size="small" label={link.org} />
      </Tooltip>

      <Tooltip
        title={
          <NodeLinkChipTooltipFormatter
            limitChipWidth={props.limitChipWidth}
            title="Division"
            chipLabel={link.div}
          />
        }
      >
        <Chip color="primary" size="small" label={link.div} />
      </Tooltip>

      <Tooltip
        title={
          <NodeLinkChipTooltipFormatter
            limitChipWidth={props.limitChipWidth}
            title="Product"
            chipLabel={link.prod}
          />
        }
      >
        <Chip color="primary" size="small" label={link.prod} />
      </Tooltip>

      <Tooltip
        title={
          <NodeLinkChipTooltipFormatter
            limitChipWidth={props.limitChipWidth}
            title="Family"
            chipLabel={link.family}
          />
        }
      >
        <Chip color="primary" size="small" label={link.family} />
      </Tooltip>

      <Tooltip
        title={
          <NodeLinkChipTooltipFormatter
            limitChipWidth={props.limitChipWidth}
            title="Version"
            chipLabel={link.version}
          />
        }
      >
        <Chip color="primary" size="small" label={link.version} />
      </Tooltip>

      <Tooltip
        title={
          <NodeLinkChipTooltipFormatter
            limitChipWidth={props.limitChipWidth}
            title="Node"
            chipLabel={link.node}
          />
        }
      >
        <Chip
          sx={{ backgroundColor: getNodeTypeColor(props.type ?? ""), color: "white" }}
          size="small"
          label={link.node}
        />
      </Tooltip>
    </Breadcrumbs>
  )
}

export default NodeLinkChips
